module.exports = __webpack_public_path__ + "static/media/banner_3.1592ba25.jpg";